var map = {
	"./CloseModel.svg": "6e36",
	"./CustomerLight.svg": "f623",
	"./Email_verify.svg": "6672",
	"./GST.svg": "c51f",
	"./Mask.svg": "a8c5",
	"./Phone_verify.svg": "7fb5",
	"./Search.svg": "32f1",
	"./Vector_2.svg": "bea2",
	"./Warehouse.svg": "1d66",
	"./add.svg": "eef4",
	"./amazon-card.svg": "629a",
	"./amazon-icon (2).svg": "0d9b",
	"./amazon-icon.svg": "8575",
	"./back_arrow.svg": "73da",
	"./cancelCircle.svg": "ee94",
	"./channels.svg": "f07a",
	"./cloud-computing.svg": "d236",
	"./dashboard.svg": "57a8",
	"./delete-red.svg": "63fd",
	"./delete.svg": "d739",
	"./delivery.svg": "d3e9",
	"./done.svg": "2e1f",
	"./download.svg": "6369",
	"./edit.svg": "6582",
	"./flipkart (1) (1).svg": "755e",
	"./flipkart.svg": "25e1",
	"./flipkartIcon.svg": "172a",
	"./inventory.svg": "e793",
	"./lensinput.svg": "5968",
	"./logo.svg": "9b19",
	"./mark-shipped.svg": "0313",
	"./myntra-seeklogo.com.svg": "a782",
	"./myntra.svg": "7fd5",
	"./orders.svg": "961f",
	"./remittances.svg": "e25a",
	"./report.svg": "5fdc",
	"./settings-blue.svg": "e183",
	"./settings.svg": "e9b0",
	"./shipment.svg": "5c74",
	"./transfer.svg": "1f3c",
	"./upload (1).svg": "20ff",
	"./upload.svg": "c118",
	"./uploadicon.svg": "fd2c",
	"./user.svg": "0f62",
	"./van.svg": "e5e7",
	"./verified-white.svg": "f94b",
	"./verified.svg": "0c49",
	"./view-more.svg": "bfb2",
	"./wallet.svg": "bc38",
	"./warehouse-High.svg": "0867",
	"./warehousee.svg": "2da8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2f65";